<template>
  <div class="p-item">
    <div @click="chooseProduct(eightd)" class="p-left">
      <img v-if="imagePath" class="l-img" :src="BASE_URL+imagePath">
      <div class="l-icon">
        <img src="../../assets/image/icon_quanhuafu.png">
        <img src="../../assets/image/icon_huafu.png">
      </div>
      <div class="l-info">
        新品上市
      </div>
    </div>
    <div class="p-right">
      <p class="r-title">{{cnName}}</p>
      <p class="r-model">{{title}}</p>
      <div class="r-spec">
        <p v-html='description'></p>
      </div>
      <div class="r-color" v-if="colorImage">
        <img :src="BASE_URL+colorImage">
      </div>
      <p class="r-price">RMB {{price}}</p>
    </div>
  </div>
</template>
<style scoped lang="less">
  @border:rgb(238,238,238);
  @red:rgb(220,40,40);
  @blue: #1db6ea;
  @fontColor: #999999;
  .p-item {
    border-bottom: 1px solid @border;
    padding: 22px 26px 15px 26px;
    display: flex;
    align-items: flex-start;
    .p-left {
      width: 100px;
      min-height: 140px;
      position: relative;
      display: flex;
      align-items: center;
      .l-img {
        width: 100%;
      }
      .l-icon {
        position: absolute;
        right: 0;
        top: 0;
        &>img {
          height: 12px;
        }
      }
      .l-info {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 16px;
        line-height: 16px;
        text-align: center;
        background-color: @red;
        color: #ffffff;
        font-size: 9px;
      }
    }
    .p-right {
      width: 180px;
      padding-left: 40px;
      .r-title {
        font-size: 13px;
        color: #4d4d4d;
      }
      .r-model {
        font-size: 17px;
        color: #4d4d4d;
        margin: 2px 0 10px 0;
      }
      .r-spec {
        font-size: 11px;
        color: #8a8a8a;
      }
      .r-color {
        display: flex;
        margin-top: 7px;
        &>img {
          width: 17px;
          height: 17px;
          margin-right: 5px;
        }
      }
      .r-price {
        font-size: 18px;
        margin-top: 10px;
        color: @blue;
      }
    }
  }
</style>
<script>

    export default{
        data(){
            return{
              BASE_URL: BASE_URL,
              title: this.goods.title,
              eightd: this.goods.eightd,
              price: this.goods.price,
              cnName: this.goods.cnName,
              enName: this.goods.enName,
              techimage1: this.goods.techimage1,
              imagePath: this.goods.imagePath,
              colorImage: this.goods.colorImage,
              description: this.goods.des
            }
        },
        props:{
          goods: Object
        },
        computed: {
          test() {
            console.log(this.goods)
            return this.goods.price;
          }
        },
        methods: {
          chooseProduct(_8d) {
            this.$router.push({path:'/Product',query: {
              eightD: _8d
            }})
          }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/common/ProductComponent.vue